import type { BundleComponentsData } from "../types";
import {
  BundleComponentsCarousel,
  sortBundleComponentsByPriceDesc,
} from "./ProductDetailCard";

interface Props {
  data: BundleComponentsData;
  sessionToken: string;
}

export default function BundleComponentsCard({ data, sessionToken }: Props) {
  const components = data.bundleComponents?.length
    ? sortBundleComponentsByPriceDesc(data.bundleComponents)
    : [];

  if (components.length === 0) {
    return null;
  }

  return (
    <BundleComponentsCarousel
      components={components}
      bundleSize={data.bundleSize ?? components.length}
      sessionToken={sessionToken}
    />
  );
}
